import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}definicion_formato_bancos`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}definicion_formato_bancos/${id}`);
  return response;
};

const getDetail = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}definicion_formato_bancos/${id}`);
  return response;
};

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}definicion_formato_bancos`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}definicion_formato_bancos`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}definicion_formato_bancos/${id}`);
  return response;
};

export { getAll, getById, getDetail, insert,update, drop };
